import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTrendingDownLarge = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21.75 18L12.75 9L9 12.75L2.25 6M21.75 18V12M21.75 18H15.75", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTrendingDownLarge);
const Memo = memo(ForwardRef);
export default Memo;
